const RELOADED_AT_KEY = 'stale-chunk-reloaded-at';
const RELOAD_COOLDOWN_MS = 10_000;

let reloading = false;

/**
 * A tab opened before a deploy still asks for the old build's code-split
 * chunks. They no longer exist, the host answers with the SPA's index.html,
 * and the dynamic import fails: the next page the user opens crashes into the
 * error boundary (the "500" screen). Vite reports every failed dynamic import
 * as a `vite:preloadError` event, so reload on it: the page comes back on the
 * new build, on the route the user was heading to.
 *
 * At most one reload per cooldown, so a chunk that is really broken still
 * shows the error instead of looping; without sessionStorage there is no way
 * to tell, so no reload.
 */
export const reloadOnStaleChunk = () => {
  window.addEventListener('vite:preloadError', () => {
    try {
      const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));
      if (Date.now() - reloadedAt < RELOAD_COOLDOWN_MS) return;
      sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
      return;
    }
    reloading = true;
    window.location.reload();
  });
};

/** True once a reload for a stale chunk is on its way. */
export const isReloadingForStaleChunk = () => reloading;
